import { type IconProps, Icon } from "@chakra-ui/icon";

const DiscountIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 16 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.00016 5.49967H6.00683M10.0002 9.49967H10.0068M10.6668 4.83301L5.3335 10.1663M14.6668 7.49967C14.6668 11.1816 11.6821 14.1663 8.00016 14.1663C4.31826 14.1663 1.3335 11.1816 1.3335 7.49967C1.3335 3.81778 4.31826 0.833008 8.00016 0.833008C11.6821 0.833008 14.6668 3.81778 14.6668 7.49967ZM6.3335 5.49967C6.3335 5.68377 6.18426 5.83301 6.00016 5.83301C5.81607 5.83301 5.66683 5.68377 5.66683 5.49967C5.66683 5.31558 5.81607 5.16634 6.00016 5.16634C6.18426 5.16634 6.3335 5.31558 6.3335 5.49967ZM10.3335 9.49967C10.3335 9.68377 10.1843 9.83301 10.0002 9.83301C9.81607 9.83301 9.66683 9.68377 9.66683 9.49967C9.66683 9.31558 9.81607 9.16634 10.0002 9.16634C10.1843 9.16634 10.3335 9.31558 10.3335 9.49967Z"
				stroke="#334155"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default DiscountIcon;
